import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import looppa from 'looppa';
import FormField from 'components/form/form-field';
import Icon from 'components/icon';

function Label({ id, text }) {
    return (
        <label className="form-field--title-label" htmlFor={id}>
            {text}
        </label>
    );
}

Label.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

// function uniqueItems(items, id) {
//     return items.map((item, idx) => {
//         return Object.assign({}, item, {
//             id: `${ id }-${ idx }`,
//             name: `${ id }`,
//         });
//     });
// }

function findValue(data, value) {
    function iterate(a) {
        if (a.value === value) {
            result = a;
            return true;
        }
        return Array.isArray(a.value) && a.value.some(iterate);
    }

    var result;
    data.some(iterate);
    return result;
}

/**
 * We will compose the following markup using many props coming from the parent component
 * @extends Component<IFormFieldSelect>
 * @constructor
 */
class Select extends Component {
    componentWillUpdate(nextProps) {
        const { hasFocus, setStateClasses } = this.props;
        if (nextProps.hasFocus !== hasFocus) {
            setStateClasses({
                'form-field__has-focus': nextProps.hasFocus,
                'form-field__is-empty': !nextProps.value,
            });
        }
    }

    renderOption(item) {
        return (
            <option key={item.id} value={item.value}>
                {item.label || item.value}
            </option>
        );
    }

    renderOptionGroup(options, item, id) {
        return (
            <optgroup key={id} label={item.label}>
                {options}
            </optgroup>
        );
    }

    renderOptions(items, id) {
        let select = [];
        items.forEach((item, idLevelOne) => {
            if (Array.isArray(item.value)) {
                let options = item.value.map((option, idLevelTwo) => {
                    return this.renderOption(
                        Object.assign({}, option, {
                            id: `${ id }-${ idLevelOne }-${ idLevelTwo }`,
                            name: `${ id }`,
                        }),
                    );
                });
                select.push(this.renderOptionGroup(options, item, `${ id }-${ idLevelOne }`));
            } else {
                select.push(
                    this.renderOption(
                        Object.assign({}, item, {
                            id: `${ id }-${ idLevelOne }`,
                            name: `${ id }`,
                        }),
                    ),
                );
            }
        });
        return select;
    }

    render() {
        const { label, id, items, value, state, onFocus, onBlur, updateValue, placeholder, actionCount } = this.props;
        let labelValue = placeholder || items[0].label || items[0].value;

        if (value) {
            const activeItem = findValue(items, value);
            labelValue = activeItem.label || activeItem.value;
        }

        return [
            label ? <Label key="label" id={id} text={label}/> : null,
            <div key="content" className="form-field--input-container" data-action-count={actionCount + 1}>
                <select
                    className="form-field--select-input"
                    id={id}
                    name={id}
                    disabled={state.disabled}
                    value={value}
                    onChange={e => updateValue(e.target.value)}
                    onFocus={onFocus}
                    onBlur={onBlur}
                >
                    {placeholder ? (
                        <option disabled defaultValue>
                            {placeholder}
                        </option>
                    ) : (
                        ''
                    )}
                    {this.renderOptions(items, id)}
                </select>
                <label className="form-field--input" htmlFor={id}>
                    {labelValue}
                </label>
                <div className="form-field--actions">
                    <span className="form-field--action form-field--action__arrow">
                        <Icon symbol="chevron-down" size="small"/>
                    </span>
                </div>
            </div>,
        ];
    }
}

Select.propTypes = {
    hasFocus: PropTypes.bool,
    setStateClasses: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    actionCount: PropTypes.number.isRequired,
    onFocus: PropTypes.func.isRequired,
    updateValue: PropTypes.func.isRequired,
    /** @type {IFormFieldSelectItems} */
    items: PropTypes.array.isRequired,
    id: PropTypes.string,
    facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    state: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    messages: PropTypes.object,
};

Select.defaultProps = {
    facet: [],
};

FormFieldInput.propTypes = {
    facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

FormFieldInput.defaultProps = {
    facet: 'base',
};

export default function FormFieldInput(props) {
    const { facet, ...attrs } = props;
    return <FormField {...attrs} facet={(Array.isArray(facet) ? facet : [facet]).concat(['input', 'select'])}
        component={Select}/>;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/form/form-field-select/index.js